// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the RequestPremiumLicenseContainer */ export const RequestPremiumLicenseContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-requestpremiumlicensecontainer" */ "./RequestPremiumLicenseContainer")).then((bundle)=>{
        return {
            default: bundle.RequestPremiumLicenseContainer
        };
    });
/** Lazy-loaded RequestPremiumLicenseContainer */ export const LazyRequestPremiumLicenseContainer = /*#__PURE__*/ lazy(RequestPremiumLicenseContainerLazyLoader);
